// extracted by mini-css-extract-plugin
module.exports = {"ManageUser":"ManageUser_ManageUser__1MXJA"};